import { deleteCustomerPaymentMethod, getStripeCustomer, postSetUpIntent, getAllCustomerPaymentMethods,createCheckoutSession} from '../services/payments';

export const GET_PAYMENT_CARDS_REQUEST = 'GET_PAYMENT_CARDS_REQUEST';
export const GET_PAYMENT_CARDS_SUCCESS = 'GET_PAYMENT_CARDS_SUCCESS';
export const GET_PAYMENT_CARDS_FAILURE = 'GET_PAYMENT_CARDS_FAILURE';
export const GET_STRIPE_CUSTOMER_REQUEST = 'GET_STRIPE_CUSTOMER_REQUEST';
export const GET_STRIPE_CUSTOMER_SUCCESS = 'GET_STRIPE_CUSTOMER_SUCCESS';
export const GET_STRIPE_CUSTOMER_FAILURE = 'GET_STRIPE_CUSTOMER_FAILURE';
export const ADD_PAYMENT_CARD_REQUEST = 'ADD_PAYMENT_CARD_REQUEST';
export const ADD_PAYMENT_CARD_SUCCESS = 'ADD_PAYMENT_CARD_SUCCESS';
export const ADD_PAYMENT_CARD_FAILURE = 'ADD_PAYMENT_CARD_FAILURE';
export const DELETE_PAYMENT_CARD_REQUEST = 'DELETE_PAYMENT_CARD_REQUEST';
export const DELETE_PAYMENT_CARD_SUCCESS = 'DELETE_PAYMENT_CARD_SUCCESS';
export const DELETE_PAYMENT_CARD_FAILURE = 'DELETE_PAYMENT_CARD_FAILURE';
export const SETUP_PAYMENT_REQUEST_REQUEST = 'SETUP_PAYMENT_REQUEST_REQUEST';
export const SETUP_PAYMENT_REQUEST_SUCCESS = 'SETUP_PAYMENT_REQUEST_SUCCESS';
export const SETUP_PAYMENT_REQUEST_FAILURE = 'SETUP_PAYMENT_REQUEST_FAILURE';
export const SETUP_STRIPE_CHECKOUT_REQUEST_REQUEST = 'SETUP_STRIPE_CHECKOUT_REQUEST_REQUEST';
export const SETUP_STRIPE_CHECKOUT_REQUEST_SUCCESS = 'SETUP_STRIPE_CHECKOUT_REQUEST_SUCCESS';
export const SETUP_STRIPE_CHECKOUT_REQUEST_FAILURE = 'SETUP_STRIPE_CHECKOUT_REQUEST_FAILURE';
export const GET_CARDS_REQUEST_REQUEST = 'GET_CARDS_REQUEST_REQUEST';
export const GET_CARDS_REQUEST_SUCCESS = 'GET_CARDS_REQUEST_SUCCESS';
export const GET_CARDS_REQUEST_FAILURE = 'GET_CARDS_REQUEST_FAILURE';

export const STRIPE_CONFIRM_PAYMENT_INTENT_REQUEST = 'STRIPE_CONFIRM_PAYMENT_INTENT_REQUEST';
export const STRIPE_CONFIRM_PAYMENT_INTENT_SUCCESS = 'STRIPE_CONFIRM_PAYMENT_INTENT_SUCCESS';


export function deleteCard(data, callback) {
  return dispatch => {
    dispatch({type: DELETE_PAYMENT_CARD_REQUEST});
    return deleteCustomerPaymentMethod(data).then(res => {
      dispatch({type: DELETE_PAYMENT_CARD_SUCCESS, payload: res});
      if (callback) {
        callback({status: true, data: res});
      }
    }).catch(err => {
      dispatch({type: DELETE_PAYMENT_CARD_FAILURE, payload: err});
      if (callback) {
        callback({status: false, data: err});
      }
    });
  };
}

export function requestStripeCustomer(callback) {
  return dispatch => {
    dispatch({type: GET_STRIPE_CUSTOMER_REQUEST});
    return getStripeCustomer().then(res => {
      dispatch({type: GET_STRIPE_CUSTOMER_SUCCESS, payload: res});
      if (callback) {
        callback({status: true, data: res});
      }
    }).catch(err => {
      dispatch({type: GET_STRIPE_CUSTOMER_FAILURE, payload: err});
      if (callback) {
        callback({status: false, data: err});
      }
    });
  };
}

export function setUpIntent(callback){
  return dispatch => {
    dispatch({type: SETUP_PAYMENT_REQUEST_REQUEST});
    return postSetUpIntent().then(res => {
      dispatch({type: SETUP_PAYMENT_REQUEST_SUCCESS, payload: res});
      if (callback) {
        callback({status: true, data: res});
      }
    }).catch(err => {
      dispatch({type: SETUP_PAYMENT_REQUEST_FAILURE, payload: err});
      if (callback) {
        callback({status: false, data: err});
      }
    });
  };
}
export function setUpStripeCheckout(data,callback){
  return dispatch => {
    dispatch({type: SETUP_STRIPE_CHECKOUT_REQUEST_REQUEST});
    return createCheckoutSession(data).then(res => {
      dispatch({type: SETUP_STRIPE_CHECKOUT_REQUEST_SUCCESS, payload: res});
      if (callback) {
        callback({status: true, data: res});
      }
    }).catch(err => {
      dispatch({type: SETUP_STRIPE_CHECKOUT_REQUEST_FAILURE, payload: err});
      if (callback) {
        callback({status: false, data: err});
      }
    });
  };
}

export function getAllUserPaymentMethods(callback){
  return dispatch => {
    dispatch({type: GET_CARDS_REQUEST_REQUEST});
    return getAllCustomerPaymentMethods().then(res => {
      dispatch({type: GET_CARDS_REQUEST_SUCCESS, payload: res});
      if (callback) {
        callback({status: true, data: res});
      }
    }).catch(err => {
      dispatch({type: GET_CARDS_REQUEST_FAILURE, payload: err});
      if (callback) {
        callback({status: false, data: err});
      }
    });
  };
}

export function requestConfirmation() {
  return dispatch => {
    dispatch({type: STRIPE_CONFIRM_PAYMENT_INTENT_REQUEST});
  };
}

export function finishConfirmation() {
  return dispatch => {
    dispatch({type: STRIPE_CONFIRM_PAYMENT_INTENT_SUCCESS});
  };
}


// WEBPACK FOOTER //
// ./src/actions/paymentsActions.js